import { ButtonBar, Dropdown, DropdownButton, Tabs } from '@ygtechnologies/rubus-ui';
import theme from './SelectCompanyMenu.module.scss';
import { Trans } from '@lingui/react/macro';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/pro-light-svg-icons';
import React, { useEffect, useRef, useState } from 'react';
import { useOnWindowResize } from '@/utils/hooks';


interface SelectCompanyMenuProps {
    companyList: { id: number | null; companyName: string }[];
    activeTab: number | null;
    setActiveTab: (boolean) => void;
}

const percentageWindowSizeBeforeDropdown = 0.75;
const breakToSmallScreen = 768;

export const SelectCompanyMenu: React.FC<SelectCompanyMenuProps> = ({ companyList, activeTab, setActiveTab }) => {
    const [showButtons, setShowButtons] = useState(false);
    const buttonRef = useRef<HTMLDivElement>(null);

    const checkWindowWidth = () => {
        const el = buttonRef.current;
        if ((el && (window.innerWidth * percentageWindowSizeBeforeDropdown) < el.offsetWidth) || window.innerWidth < breakToSmallScreen) {
            setShowButtons(false);
        } else {
            setShowButtons(true);
        }
    };

    useEffect(() => {
        if (!buttonRef.current || companyList.length === 0) {
            return;
        }
        checkWindowWidth();
    }, [buttonRef, companyList]);

    useOnWindowResize(checkWindowWidth, 500);

    return (
        <div className={theme.menuWrapper}>
            <div className={theme.relativeContainer}>
                <div style={{ visibility: showButtons ? 'visible' : 'hidden' }}>
                    <ButtonBar className={theme.buttonBar}>
                        <div ref={buttonRef} className={theme.refContainer}>
                            <Tabs
                                className={theme.toggleButtons}
                                variant="pill"
                                size="sm"
                                activeId={activeTab === null ? 'all' : String(activeTab)}
                                onChange={(id) => setActiveTab(id === 'all' ? null : Number(id))}>
                                <Tabs.Tab id="all" label={<Trans>All</Trans>} />
                                <Tabs.Tab id="-1" label={<Trans>Not registered</Trans>} />
                                {companyList.map((x) => (
                                    <Tabs.Tab key={x.id} id={String(x.id)} label={x.companyName} />
                                ))}
                            </Tabs>
                        </div>
                    </ButtonBar>
                </div>
                <div className={theme.defaultDropdown} style={{ visibility: showButtons ? 'hidden' : 'visible' }}>
                    <DropdownButton
                        className={theme.dropdownItem}
                        variant="secondary"
                        label={
                            <div className={theme.sortBy}>
                                {activeTab !== null ? (
                                    companyList && companyList.find((e) => e.id === activeTab)?.companyName
                                ) : (
                                    <Trans>All</Trans>
                                )}{' '}
                                <span className={theme.iconWrapper}>
                                    <FontAwesomeIcon icon={faChevronDown} />
                                </span>
                            </div>
                        }>
                        <Dropdown.Item onClick={() => setActiveTab(null)}>
                            <Trans>All</Trans>
                        </Dropdown.Item>
                        {companyList.map((x) => (
                            <Dropdown.Item key={x.id} onClick={() => setActiveTab(x.id)}>
                                {x.companyName}
                            </Dropdown.Item>
                        ))}
                    </DropdownButton>
                </div>
            </div>
        </div>
    );
};
